import CameraRollOutlinedIcon from "@mui/icons-material/CameraRollOutlined";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import PersonOffOutlined from "@mui/icons-material/PersonOffOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import SubscriptionIcon from "@mui/icons-material/SubscriptionsOutlined"; // Subscription packages icon
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import CrewOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined"; // Crew icon
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { Menu, MenuItem, ProSidebar } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Link } from "react-router-dom";
import { tokens } from "../../theme";

const Item = ({ title, to, icon, selected, setSelected }) => {
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: '#6e0506',
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");

  return (
    <Box
      sx={{
        height: "100vh",
        position: "sticky",
        top: 0,
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
          height: "100vh",
          overflowY: "auto !important",
          scrollbarWidth: "thin",
        },
        "& .pro-menu": {
          overflowY: "auto !important",
          overflowX: "hidden !important",
          maxHeight: "100%",
          scrollbarWidth: "thin",
          msOverflowStyle: "auto",
        },
        "& .pro-menu::-webkit-scrollbar": {
          width: "8px",
        },
        "& .pro-sidebar-inner::-webkit-scrollbar": {
          width: "8px",
        },
        "& .pro-menu::-webkit-scrollbar-thumb, & .pro-sidebar-inner::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(110, 5, 6, 0.35)",
          borderRadius: "8px",
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#6e0506 !important",
        },
        "& .pro-menu-item.active": {
          color: "#6e0506 !important",
          backgroundColor: "rgba(110, 5, 6, 0.2) !important", // Semi-transparent background
          fontWeight: "bold !important",
          borderRadius: "8px",
          marginRight: "10px",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed} height="100vh">
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "20px 0 20px 0",
              color: '#6e0506',
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography
                  variant="h3"
                  color={'#6e0506'}
                  sx={{ fontWeight: "bold" }}
                >
                  Admin
                </Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="5px">
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  color={'#6e0506'}
                  fontWeight="bold"
                  sx={{ m: "20px 0 0 0" }}
                ></Typography>
              </Box>
            </Box>
          )}

          <Box
            sx={{
              minHeight: "calc(100vh - 110px)",
              paddingLeft: isCollapsed ? 0 : "10%",
              paddingBottom: "24px",
            }}
          >
            <Item
              title="Dashboard"
              to="/dd"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{
                m: "25px 0 5px 20px",
                fontWeight: "bold",
              }}
            >
              Castings
            </Typography>
            <Item
              title="Pending Castings"
              to="/pending"
              icon={<GroupOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Approved Castings"
              to="/approved"
              icon={<GroupAddOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Rejected Castings"
              to="/rejected"
              icon={<PersonOffOutlined />}
              selected={selected}
              setSelected={setSelected}
            />

            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{
                m: "25px 0 5px 20px",
                fontWeight: "bold",
              }}
            >
              Users
            </Typography>
            <Item
              title="Actors"
              to="/actors"
              icon={<PeopleOutlineIcon />} // New icon for actors
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Directors"
              to="/directors"
              icon={<CameraRollOutlinedIcon />} // New icon for directors
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Producers"
              to="/producers"
              icon={<CrewOutlinedIcon />} // New icon for crew
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Crew"
              to="/crew"
              icon={<CrewOutlinedIcon />} // New icon for crew
              selected={selected}
              setSelected={setSelected}
            />

            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{
                m: "25px 0 5px 20px",
                fontWeight: "bold",
              }}
            >
              Subscription
            </Typography>
            <Item
              title="Packages"
              to="/packages"
              icon={<SubscriptionIcon />} // New icon for subscription packages
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Coupons"
              to="/coupons"
              icon={<LocalOfferOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Support Requests"
              to="/support-requests"
              icon={<ContactSupportOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
